export const inputCharLimit = (function () {
  const init = (el) => {
    const input = $(el);

    input.each(function () {
      const initLength = $(this).data('charlimit');
      const initElCharLength = $(this).val().length;

      const charIndicator = $(`<span class="limit-indicator__limit">${initElCharLength}/${initLength}</span>`);
      const charIndicatorContainer = $(`<div class="text-right limit-indicator"></div>`);

      $(this).attr('maxlength', initLength);

      if (initElCharLength > initLength) {
        $(this).addClass('is-invalid');
        charIndicatorContainer.addClass('text-danger');
      }

      $(this).before(charIndicatorContainer.append(charIndicator));

      $(this).on('change keyup paste', (event) => {
        const target = $(event.target);

        let currentValue = target.val();
        const currentLength = currentValue.length;
        const elMaxlength = target.data('charlimit');

        target.removeClass('is-invalid');
        charIndicatorContainer.removeClass('text-danger');

        if (currentLength > elMaxlength) {
          target.addClass('is-invalid');
          charIndicatorContainer.addClass('text-danger');
          currentValue = currentValue.substr(0, elMaxlength);
          target.val(currentValue);
        }

        charIndicator.text(`${currentValue.length}/${elMaxlength}`);
      });
    });
  };

  return {
    init
  };
})();
